module.exports = __webpack_public_path__ + "img/snpark_thumbnail.ba110975.jpg";